import styled from "@emotion/styled"
import theme from "../../particles/Theme"

const StyledMenu = styled.ul`
  color: #fff;
  display: ${(props: StyledMenuProps) => (props.mobile ? `block` : `flex`)};
  align-self: center;
  position: relative;

  ul.mm {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    visibility: hidden;
    opacity: 0;
    width: 100%;
    top: 7.8rem;
    z-index: 1000;

    @media (min-width: ${theme.breakpoints[1]}) {
      &:before > a li:hover {
        color: ${theme.colors.primaryHover};
      }
    }

    > li {
      align-self: stretch;
      background: ${theme.colors.primary};
      padding: 2rem;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        left: 2rem;
        top: 5rem;
        height: 3px;
        width: 80%;
        background: white;
      }

      > ul {
        display: inline;
        visibility: hidden;
        opacity: 0;
        position: unset;
        background: ${theme.colors.primary};

        > li {
          padding: 0.25em 0;

          & > a {
            font-size: 0.9em;
            font-weight: 400;
            text-transform: unset;
            color: white;

            &:hover {
              text-decoration: underline;
              color: white;
              background: unset !important;
            }
          }
        }
      }
    }

    &:before {
      content: "";
      color: ${theme.colors.primary};
      position: absolute;
      left: 18%;
      top: 22px;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;

      border-bottom: 20px solid ${theme.colors.primary};
    }
  }

  > li:hover {
    > ul.mm {
      visibility: visible;
      opacity: 1;

      > li > ul {
        visibility: visible;
        opacity: 1;
      }
    }

    > ul:not(.mm) {
      visibility: visible;
      opacity: 1;

      > a li:hover {
        background: ${theme.colors.primaryHover};
      }
    }
  }

  ul {
    display: inline-block;
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 200px;
    z-index: 100;
    transition: visibility 0s, opacity 0.3s ease;

    a {
      li {
        margin: 0;
      }

      &:before {
        display: none;
      }
    }

    > a li {
      background: ${theme.colors.primary};
      color: #fff;
      padding: 1rem;
    }
  }

  li {
    list-style: none;
    padding: 0 10px;
    align-self: center;

    a {
      text-decoration: none;
      color: ${(props: StyledMenuProps) => props.fontColor};
      z-index: 99;
      text-transform: uppercase;
      font-weight: 700;

      &:before {
        content: "";
        position: absolute;
        width: 80%;
        height: 2px;
        bottom: -5px;
        left: 10%;
        background-color: #fff;
        visibility: hidden;
        transform: scaleX(0);
        transition: all 0.3s ease-in-out;
      }
      @media (min-width: ${theme.breakpoints[1]}) {
        &:not(.no-line):hover:before {
          visibility: visible;
          transform: scaleX(1);
        }
      }
    }
  }

  .primaryActive {
    color: ${theme.colors.primary};
  }

  .underlineActive {
    &::before {
      content: "";
      position: absolute;
      width: 80%;
      height: 2px;
      bottom: -5px;
      left: 10%;
      background-color: #fff;
      transform: scaleX(0);
      transition: all 0.3s ease-in-out;
    }
  }
`

type StyledMenuProps = {
  fontColor: string
  mobile?
}

export default StyledMenu
